import React, { FC } from 'react'
import { Row } from '../../../../legacy-design-system/form'
import { ProjectFields } from './project-fields'
import { DefaultPriority } from './default-priority'
import { AdditionalJiraFieldsList } from './additional-jira-fields/additional-jira-fields-list'
import { TwoWayIntegration } from './two-way-integration'
import { AutoCreateTicketsFields } from './auto-create-tickets-fields'
import {
  BugtrackerConfig,
  NgBugtrackerMaintenanceWindowResource
} from '../api/shared'
import { ApplicationsFields } from './applications-fields'
import { css } from '@emotion/css'
import { FormCheckbox } from '../../../../legacy-design-system/checkbox'
import { JiraFormFieldTypes } from './jira-form-field-types'
import { useIntl } from 'react-intl'
import { useFormContext } from 'react-hook-form'
import { JiraIntegrationForm } from './jira-form-schema'
import { MaintenanceWindowConfig } from './maintenance-window-config'

export const AssessFields: FC<{
  bugtracker?: BugtrackerConfig
  maintenanceWindow?: NgBugtrackerMaintenanceWindowResource
}> = ({ bugtracker, maintenanceWindow }) => {
  const { formatMessage } = useIntl()
  const { watch } = useFormContext<JiraIntegrationForm>()

  const watchProject = watch(JiraFormFieldTypes.PROJECT)
  const watchIssueType = watch(JiraFormFieldTypes.ISSUE_TYPE)

  return (
    <>
      <ApplicationsFields />
      <ProjectFields bugtracker={bugtracker} />
      <Row
        className={css`
          align-items: flex-start;
        `}
      >
        <DefaultPriority />
        <AdditionalJiraFieldsList bugtracker={bugtracker} />
      </Row>
      {watchProject && watchIssueType && (
        <FormCheckbox
          name={JiraFormFieldTypes.EXCLUDE_SENSITIVE_INFO}
          label={formatMessage({
            id: 'action_integrationsSettings_excludeSensitiveInfo'
          })}
        />
      )}
      <TwoWayIntegration />
      <AutoCreateTicketsFields />

      {watchProject && watchIssueType && (
        <FormCheckbox
          name={JiraFormFieldTypes.SEND_TAGS}
          label={formatMessage({
            id: 'action_integrationsSettings_sendTagsAsLabels'
          })}
        />
      )}

      {watchProject && watchIssueType && (
        <MaintenanceWindowConfig maintenanceWindow={maintenanceWindow} />
      )}
    </>
  )
}
